import { Button, Icon, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function InvalidFormatModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation(
    TranslationsKeys.ADMISSION_AND_ENROLLMENTS_BENEFIT_ALLOCATION,
  );

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <Container fluid>
        <Row>
          <Col xs={12} className="text-center pt-3">
            <Icon name="warning" color="secondary" size="50px" />
          </Col>
        </Row>
        <p className="text-dark fs-20 mt-4 mb-3 text-center">
          {t('errors.title')}
        </p>
        <p className="text-dark fs-16 mb-4 text-center">
          {t('errors.invalidFormat')}
        </p>
        <Row>
          <Col xs={12} className="text-center pb-2">
            <Button onClick={onClose} text={t('errors.back')} fullwidth />
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}
